import React, { useState } from 'react';
import { TextField, Grid, Button, Container, Box, Typography, Card, CardContent, CircularProgress } from '@mui/material';
import axios from '../Axiosinstance';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Header from '../components/Header';
import { useNavigate } from 'react-router-dom';
import { Download, Search } from '@mui/icons-material';
import { HelpOutline } from '@mui/icons-material';
import { Tooltip, IconButton } from '@mui/material';

function StudentReport() {
  const [data, setData] = useState([]);
  const [year, setYear] = useState('');
  const [fetching, setFetching] = useState(false);
  const [data2, setData2] = useState([]);
  const [startyear, setStartYear] = useState('');
  const [endyear, setEndYear] = useState('');
  const [fetching2, setFetching2] = useState(false); const navigate = useNavigate();


  const fetchData = async (year) => {
    setFetching(true);
    try {
      const response = await axios.get(`registrationadvances/by-year?year=${year}`);
      setData(response.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setFetching(false);
    }
  };

  const fetchData2 = async () => {
    setFetching2(true);  // Use fetching2 here
    try {
      const response = await axios.get(`registrationadvances/api/students`, {
        params: {
          startYear: startyear,
          endYear: endyear,
        },
      });
      setData2(response.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setFetching2(false);  // Use fetching2 here
    }
  };



  const handleDownload = () => {
    if (data.length === 0) {
      alert('No data available to export');
      return;
    }

    // Map response data to the required fields with custom headings
    const mappedData = data.map((item, index) => {
      let statusLabel;
      switch (item.status) {
        case 'withdraw':
          statusLabel = 'Left Before Completion';
          break;
        case 'active':
          statusLabel = 'Existing';
          break;
        case 'deferred':
          statusLabel = 'Deferred';
          break;
        case 'alumni':
          statusLabel = 'Graduated';
          break;
        case 'pending':
          statusLabel = 'Pending';
          break;
        default:
          statusLabel = item.status;
      }

      return {
        'S/NO': index + 1,
        'NAME OF STUDENT': item.student?.name,
        'NRIC NUMBER/FIN': item.student?.nric,
        'NATIONALITY': item?.nationality,
        'IDENTITY OR PASS TYPE': item?.proofType,
        'GENDER': item.student?.gender,
        'DATE OF BIRTH': item.student?.dob,
        'HIGHEST ACADEMIC QUALIFICATION ATTEND PRIOR TO COURSE ENROLLMENT': item?.institutionDetails[0]?.qualificationsAchieved,
        'STUDENT TYPE': item.batch?.courseType,
        'TITLE OF CPE-PERMITTED COURSE ENROLLED': item.batch?.course,
        'TITLE OF MODULE': "",
        'MODE OF COURSE DELIVERY': item.batch?.venue,
        'TOTAL COURSE FEES EXCLUDING GST(IN S$)': item.courseFee,
        'COURSE COMMENCEMENT DATE(MM/YYYY)': item.scheduleDate?.[0]?.startDate,
        'STATUS OF STUDENT AS AT 31 DEC': statusLabel,
        '(EXPECTED) DATE OF GRADUATION/COMPLETION(MM/YYY)': item.scheduleDate?.[item.scheduleDate.length - 1]?.startDate,
      };
    });

    // Create the worksheet and workbook
    const ws = XLSX.utils.json_to_sheet(mappedData);

    // Set bold headers with a background color
    const headerStyle = {
      font: { bold: true },
      fill: { fgColor: { rgb: 'FFFF00' } } // Yellow background color
    };

    const headers = Object.keys(mappedData[0]);
    headers.forEach((header, idx) => {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: idx });
      if (!ws[cellAddress]) ws[cellAddress] = {};
      ws[cellAddress].s = headerStyle;
    });

    // Set column widths (optional)
    const columnWidths = [
      { wch: 10 }, // S/NO
      { wch: 30 }, // NAME OF STUDENT
      { wch: 30 }, // NRIC NUMBER/FIN
      { wch: 25 }, // NATIONALITY
      { wch: 25 }, // IDENTITY OR PASS TYPE
      { wch: 10 }, // GENDER
      { wch: 15 }, // DATE OF BIRTH
      { wch: 35 }, // HIGHEST ACADEMIC QUALIFICATION ATTEND PRIOR TO COURSE ENROLLMENT
      { wch: 20 }, // STUDENT TYPE
      { wch: 35 }, // TITLE OF CPE-PERMITTED COURSE ENROLLED
      { wch: 20 }, // TITLE OF MODULE
      { wch: 25 }, // MODE OF COURSE DELIVERY
      { wch: 30 }, // TOTAL COURSE FEES EXCLUDING GST(IN S$)
      { wch: 25 }, // COURSE COMMENCEMENT DATE(MM/YYYY)
      { wch: 25 }, // STATUS OF STUDENT AS AT 31 DEC
      { wch: 30 }, // (EXPECTED) DATE OF GRADUATION/COMPLETION(MM/YYY)
    ];
    ws['!cols'] = columnWidths;



    // Create the workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Student Report');

    // Convert to binary and trigger the download
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([wbout], { type: 'application/octet-stream' }), `Student_Report_${year}.xlsx`);
  };


  const handleDownload2 = () => {
    if (data2.length === 0) {
      alert('No data available to export');
      return;
    }

    // Map response data to the required fields with custom headings
    const mappedData = data2.map((item, index) => {
      let statusLabel;
      switch (item.status) {
        case 'withdraw':
          statusLabel = 'Left Before Completion';
          break;
        case 'active':
          statusLabel = 'Existing';
          break;
        case 'deferred':
          statusLabel = 'Deferred';
          break;
        case 'alumni':
          statusLabel = 'Graduated';
          break;
        case 'pending':
          statusLabel = 'Pending';
          break;
        default:
          statusLabel = item.status;
      }

      return {
        'S/NO': index + 1,
        'NAME OF STUDENT': item.student?.name,
        'NRIC NUMBER/FIN': item.student?.nric,
        'NATIONALITY': item?.nationality,
        'IDENTITY OR PASS TYPE': item?.proofType,
        'GENDER': item.student?.gender,
        'DATE OF BIRTH': item.student?.dob,
        'HIGHEST ACADEMIC QUALIFICATION ATTEND PRIOR TO COURSE ENROLLMENT': item?.institutionDetails[0]?.qualificationsAchieved,
        'STUDENT TYPE': item.batch?.courseType,
        'TITLE OF CPE-PERMITTED COURSE ENROLLED': item.batch?.course,
        'TITLE OF MODULE': "",
        'MODE OF COURSE DELIVERY': item.batch?.venue,
        'TOTAL COURSE FEES EXCLUDING GST(IN S$)': item.courseFee,
        'COURSE COMMENCEMENT DATE(MM/YYYY)': item.scheduleDate?.[0]?.startDate,
        'STATUS OF STUDENT AS AT 31 DEC': statusLabel,
        '(EXPECTED) DATE OF GRADUATION/COMPLETION(MM/YYY)': item.scheduleDate?.[item.scheduleDate.length - 1]?.startDate,
      };
    });

    // Create the worksheet and workbook
    const ws = XLSX.utils.json_to_sheet(mappedData);

    // Set bold headers with a background color
    const headerStyle = {
      font: { bold: true },
      fill: { fgColor: { rgb: 'FFFF00' } } // Yellow background color
    };

    const headers = Object.keys(mappedData[0]);
    headers.forEach((header, idx) => {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: idx });
      if (!ws[cellAddress]) ws[cellAddress] = {};
      ws[cellAddress].s = headerStyle;
    });

    // Set column widths (optional)
    const columnWidths = [
      { wch: 10 }, // S/NO
      { wch: 30 }, // NAME OF STUDENT
      { wch: 30 }, // NRIC NUMBER/FIN
      { wch: 25 }, // NATIONALITY
      { wch: 25 }, // IDENTITY OR PASS TYPE
      { wch: 10 }, // GENDER
      { wch: 15 }, // DATE OF BIRTH
      { wch: 35 }, // HIGHEST ACADEMIC QUALIFICATION ATTEND PRIOR TO COURSE ENROLLMENT
      { wch: 20 }, // STUDENT TYPE
      { wch: 35 }, // TITLE OF CPE-PERMITTED COURSE ENROLLED
      { wch: 20 }, // TITLE OF MODULE
      { wch: 25 }, // MODE OF COURSE DELIVERY
      { wch: 30 }, // TOTAL COURSE FEES EXCLUDING GST(IN S$)
      { wch: 25 }, // COURSE COMMENCEMENT DATE(MM/YYYY)
      { wch: 25 }, // STATUS OF STUDENT AS AT 31 DEC
      { wch: 30 }, // (EXPECTED) DATE OF GRADUATION/COMPLETION(MM/YYY)
    ];
    ws['!cols'] = columnWidths;



    // Create the workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Student Report');

    // Convert to binary and trigger the download
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([wbout], { type: 'application/octet-stream' }), `Student_Report_${year}.xlsx`);
  };


  return (
    <>
      <Header />
      <Container maxWidth="md">
        <Box sx={{ mt: 5, mb: 5 }}>
          <Typography variant="h4" align="center" gutterBottom sx={{ fontWeight: 600 }}>
            📊 Student Report Generator
          </Typography>

          {/* Report by Year Section */}
          <Card sx={{ mb: 4, borderRadius: 3, boxShadow: 3 }}>
            <CardContent>
              <Box display="flex" alignItems="center" mb={2}>
                <Typography variant="h6" sx={{ fontWeight: 500, mr: 1 }}>
                  Generate Report by Year
                </Typography>
                <Tooltip
                  title="This will fetch the full student list for the selected year."
                  disableTouchListener={false}
                  enterTouchDelay={0}
                >
                  <IconButton size="small">
                    <HelpOutline fontSize="small" />
                  </IconButton>
                </Tooltip>

              </Box>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Year"
                    fullWidth
                    variant="outlined"
                    value={year}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d{0,4}$/.test(value)) {
                        setYear(value);
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    onClick={() => fetchData(year)}
                    disabled={fetching}
                    startIcon={!fetching && <Search />}
                    sx={{ height: 56 }}
                  >
                    {fetching ? <CircularProgress size={24} /> : 'Fetch Report'}
                  </Button>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="secondary"
                    onClick={handleDownload}
                    disabled={fetching || data.length === 0}
                    startIcon={<Download />}
                    sx={{ height: 56 }}
                  >
                    Download Report
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          {/* Report by Year Range Section */}
          <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
            <CardContent>
              <Box display="flex" alignItems="center" mb={2}>
                <Typography variant="h6" sx={{ fontWeight: 500, mr: 1 }}>
                  Generate Report by Year Range
                </Typography>
                <Tooltip
                  title="This will fetch the active and alumni student list between the selected years."
                  disableTouchListener={false}
                  enterTouchDelay={0}
                >
                  <IconButton size="small">
                    <HelpOutline fontSize="small" />
                  </IconButton>
                </Tooltip>

              </Box>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={3}>
                  <TextField
                    label="Start Year"
                    fullWidth
                    variant="outlined"
                    type="number"
                    value={startyear}
                    onChange={(e) => setStartYear(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    label="End Year"
                    fullWidth
                    variant="outlined"
                    type="number"
                    value={endyear}
                    onChange={(e) => setEndYear(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    onClick={() => fetchData2()}
                    disabled={fetching2}
                    startIcon={!fetching2 && <Search />}
                    sx={{ height: 56 }}
                  >
                    {fetching2 ? <CircularProgress size={24} /> : 'Fetch Report'}
                  </Button>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="secondary"
                    onClick={handleDownload2}
                    disabled={fetching2 || data2.length === 0}
                    startIcon={<Download />}
                    sx={{ height: 56 }}
                  >
                    Download Report
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Box>
      </Container>
    </>
  );
}

export default StudentReport;
